import { render, staticRenderFns } from "./playingMethod.vue?vue&type=template&id=497bf56c&scoped=true&"
import script from "./playingMethod.vue?vue&type=script&lang=js&"
export * from "./playingMethod.vue?vue&type=script&lang=js&"
import style0 from "./playingMethod.vue?vue&type=style&index=0&id=497bf56c&lang=less&scoped=true&"
import style1 from "./playingMethod.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497bf56c",
  null
  
)

export default component.exports